module.exports = __webpack_public_path__ + "images/dingtalk/ad20160530/4-0a12205ed0c370f8d55f18adb8eb9d77.png";